import { render, staticRenderFns } from "./RePadding.vue?vue&type=template&id=1d069d9c&"
import script from "./RePadding.vue?vue&type=script&lang=js&"
export * from "./RePadding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports